/** Segment names already assigned on other cards (exclude `keepIndex`). */
export const usedSegmentNames = (segments: { name: string }[], keepIndex?: number): Set<string> => {
  const used = new Set<string>();
  segments.forEach((s, i) => {
    if (keepIndex !== undefined && i === keepIndex) return;
    if (s.name?.trim()) used.add(s.name.trim());
  });
  return used;
};

/** Dealer primary segments that can be picked for a card at `cardIndex`. */
export const segmentNameOptionsForCard = (
  availableSegments: string[],
  segments: { name: string }[],
  cardIndex: number,
): string[] => {
  const used = usedSegmentNames(segments, cardIndex);
  const current = segments[cardIndex]?.name?.trim();
  return availableSegments.filter((n) => !used.has(n) || n === current);
};

/** First primary segment not yet used in the plan list. */
export const firstUnusedSegmentName = (
  availableSegments: string[],
  segments: { name: string }[],
): string | undefined => {
  const used = usedSegmentNames(segments);
  return availableSegments.find((n) => !used.has(n));
};

/** Count of dealer primary segments not yet added to the plan. */
export const countUnusedSegments = (
  availableSegments: string[],
  segments: { name: string }[],
): number => {
  const used = usedSegmentNames(segments);
  return availableSegments.filter((n) => !used.has(n)).length;
};
